export default __webpack_public_path__ + "static/supporting-our-team-6a66168e93185626d04e3ffa3d8f60bb.mp4";